import { Card, CardContent } from '@/components/ui/Card.tsx';
import timeUtils from '@/utils/timeUtils.ts';
import TextInfoSection from '@/features/public/booking/components/TextInfoSection.tsx';
import { BookingTourBasicDataDto } from '@/features/public/booking/types/BookingTourBasicDataDto.ts';

type BookingSoldOutContentProps = {
  tourBasicInfo: BookingTourBasicDataDto;
};

/**
 * Zapisy otwarte, ale miejsc brak. Osobny ekran od „zapisy zamknięte" — powód
 * odmowy jest inny.
 *
 * Bez zaproszenia na listę rezerwową: ten ekran z definicji powstaje tylko przy
 * `waitlistAvailable === false` (pełny wyjazd z otwartą listą idzie przekierowaniem
 * na `/waitlist`), więc CTA nigdy by się tu nie pokazał.
 */
const BookingSoldOutContent = ({
  tourBasicInfo,
}: BookingSoldOutContentProps) => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-base-text">
          Na wyjazd <b>{tourBasicInfo.tourName}</b> nie ma już wolnych miejsc.
        </h1>

        <p className="text-neutral-500">
          Zapisy są otwarte, ale limit uczestników został wyczerpany. Skontaktuj
          się z organizatorem, aby dowiedzieć się o innych terminach.
        </p>
      </div>

      <Card>
        <CardContent className="space-y-6">
          <TextInfoSection
            title="Termin wyjazdu"
            info={
              <>
                <p>
                  Rozpoczęcie:{' '}
                  <span className="font-semibold">
                    {timeUtils.toDateString(tourBasicInfo.startDate)}
                  </span>
                </p>
                <p>
                  Zakończenie:{' '}
                  <span className="font-semibold">
                    {timeUtils.toDateString(tourBasicInfo.endDate)}
                  </span>
                </p>
              </>
            }
          />

          {tourBasicInfo.tourDescription &&
            tourBasicInfo.tourDescription.length > 0 && (
              <TextInfoSection
                title="Opis wyjazdu"
                info={tourBasicInfo.tourDescription}
              />
            )}
        </CardContent>
      </Card>
    </div>
  );
};

export default BookingSoldOutContent;
